import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { getApp, getHostHub } from 'owa-config';
import { isBootFeatureEnabled } from 'owa-metatags/lib/isBootFeatureEnabled';

/**
 * Checks if the BizchatSidepane SSR feature is enabled for the given mailbox.
 * @param mailboxInfo - The mailbox information to check the feature flags against.
 * @returns True if the Bizchat SSR feature is enabled for the mailbox, false otherwise.
 */
export const isBizchatSidepaneSSREnabled = (mailboxInfo: MailboxInfo): boolean => {
    if (!isAccountFeatureEnabled('mon-copilot-bizchat-ocdi', mailboxInfo)) {
        return false;
    }

    const hasSSR = isAccountFeatureEnabled('mon-copilot-bizchat-ssr', mailboxInfo);
    const hasTeamsSSR =
        getHostHub() === 'teamshub' &&
        isAccountFeatureEnabled('mon-copilot-bizchat-ssr-teams', mailboxInfo);

    if (!hasSSR && !hasTeamsSSR) {
        return false;
    }

    // When hosted inside a Teams hub, the Calendar app
    // acquires tokens via MSAL hosted-calendar flow for the SSR path. Gate that variant behind msal flight as well.
    if (hasTeamsSSR) {
        const app = getApp();
        if (app === 'Calendar' || app === 'CalendarDeepLink') {
            return isBootFeatureEnabled('auth-msaljs-hostedcalendar-i2');
        }
    }

    return true;
};
